import React, { Component } from 'react'
import { Carousel, Image } from 'react-bootstrap';
import bannerImg2 from './../../_assets/images/banner2.jpg';
import './Banner.css';

export default class Banner extends Component {
    render() {

        return (
            <Carousel>
                <Carousel.Item>
                    <Image alt="Banner2"  src={bannerImg2} className="d-block w-100" />
                </Carousel.Item>
                <Carousel.Item>
                    <Image alt="Banner2" src={bannerImg2} className="d-block w-100" />
                </Carousel.Item>
                <Carousel.Item>
                    <Image alt="Banner2" src={bannerImg2} className="d-block w-100" />
                    <Carousel.Caption className="carousel-caption d-none d-md-block">
                        <h5>Second slide label</h5>
                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
                    </Carousel.Caption>
                </Carousel.Item>
            </Carousel>
        );
    }
}